/** 維修報告狀態（DRAFT → COMPLETED｜REFUSED｜CANCELLED；無 reopen）。 */

export const REPAIR_REPORT_STATUS = {
  DRAFT: 'DRAFT',
  COMPLETED: 'COMPLETED',
  REFUSED: 'REFUSED',
  CANCELLED: 'CANCELLED',
};

export const REPAIR_REPORT_STATUS_LABELS = {
  DRAFT: '草稿',
  COMPLETED: '已完成',
  REFUSED: '拒修',
  CANCELLED: '已取消',
};

export const REPAIR_REPORT_STATUS_FILTER_OPTIONS = [
  { value: 'DRAFT', label: '草稿' },
  { value: 'COMPLETED', label: '已完成' },
  { value: 'REFUSED', label: '拒修' },
  { value: 'CANCELLED', label: '已取消' },
];

export const REPAIR_REPORT_INSPECTION_RESULT_OPTIONS = [
  { value: 'PASS', label: '通過' },
  { value: 'FAIL', label: '未通過' },
  { value: 'NOT_APPLICABLE', label: '不適用' },
];

export function formatRepairReportStatusLabel(status) {
  if (status == null || status === '') {
    return '-';
  }
  return REPAIR_REPORT_STATUS_LABELS[status] ?? status;
}

export function canEditRepairReport(status) {
  return status === REPAIR_REPORT_STATUS.DRAFT;
}

export function canCompleteRepairReport(status) {
  return status === REPAIR_REPORT_STATUS.DRAFT;
}

export function canRefuseRepairReport(status) {
  return status === REPAIR_REPORT_STATUS.DRAFT;
}

/** 未鎖定 DRAFT 可取消（簽收鎖定由後端擋）。更正 SN／移除品項前須先取消。 */
export function canCancelDraftRepairReport(status) {
  return status === REPAIR_REPORT_STATUS.DRAFT;
}
